import axios from 'axios'

const COZE_BASE_URL = 'https://api.coze.cn/v1'

// 独立实例，避免全局拦截器注入 SJ-Auth-Token 导致第三方 API CORS 失败
const cozeClient = axios.create()

function getToken () {
  return window._env_ && window._env_.VUE_APP_COZE_TOKEN
}

function getWorkflowId () {
  return window._env_ && window._env_.VUE_APP_COZE_WORKFLOW_ID
}

function parseWorkflowOutput (output) {
  if (!output) {
    return null
  }
  let parsed = output
  if (typeof output === 'string') {
    try {
      parsed = JSON.parse(output)
    } catch (e) {
      return null
    }
  }
  if (typeof parsed === 'string') {
    try {
      parsed = JSON.parse(parsed)
    } catch (e) {
      return null
    }
  }
  if (parsed && parsed.headers && parsed.values) {
    const result = {}
    parsed.headers.forEach((key, index) => {
      result[key] = parsed.values[index]
    })
    return result
  }
  return parsed
}

function extractWorkflowResult (body) {
  const payload = body && body.data
  if (!payload) {
    return null
  }
  if (typeof payload === 'string') {
    return parseWorkflowOutput(payload)
  }
  if (payload.output) {
    return parseWorkflowOutput(payload.output)
  }
  if (payload.headers && payload.values) {
    return parseWorkflowOutput(payload)
  }
  return null
}

export function isCozeItemTrusted (score, distance) {
  const scoreNum = Number(score)
  const distanceNum = Number(distance)
  if (Number.isNaN(scoreNum) || Number.isNaN(distanceNum)) {
    return false
  }
  return scoreNum >= 7 && distanceNum <= 2000
}

export function parseBaiduPoiResults (resultsSimp) {
  if (!resultsSimp) {
    return []
  }
  const text = String(resultsSimp).replace(/\\n/g, '\n')
  return text.split('\n').map((line) => {
    const match = line.match(/^\[(\d+)\](.+)$/)
    if (!match) {
      return null
    }
    const parts = match[2].split(';')
    if (parts.length < 8) {
      return null
    }
    const [lng, lat] = (parts[7] || '').split(',')
    return {
      index: Number(match[1]),
      uid: parts[0],
      name: parts[1],
      province: parts[2],
      city: parts[3],
      district: parts[4],
      town: parts[5],
      address: parts[6],
      lng: Number(lng),
      lat: Number(lat),
      distance: parts[8] || '',
    }
  }).filter(Boolean)
}

export function runMarketLocationWorkflow (data) {
  const token = getToken()
  const workflowId = getWorkflowId()
  if (!token) {
    return Promise.reject(new Error('未配置 Coze Token（VUE_APP_COZE_TOKEN）'))
  }
  if (!workflowId) {
    return Promise.reject(new Error('未配置 Coze Workflow ID（VUE_APP_COZE_WORKFLOW_ID）'))
  }

  return cozeClient.post(
    `${COZE_BASE_URL}/workflow/run`,
    {
      workflow_id: workflowId,
      parameters: { data },
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  ).then((response) => {
    const body = response.data || {}
    if (body.code !== 0) {
      throw new Error(body.msg || 'Coze 工作流执行失败')
    }
    const result = extractWorkflowResult(body)
    if (!result || !result.shop_id) {
      throw new Error('Coze 工作流返回数据为空')
    }
    return {
      raw: result,
      poiList: parseBaiduPoiResults(result.baidu_results_simp),
    }
  }).catch((error) => {
    if (error.response && error.response.data && error.response.data.msg) {
      throw new Error(error.response.data.msg)
    }
    throw error
  })
}



// WEBPACK FOOTER //
// ./src/services/coze.api.js